(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/betslip-systeminfo.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/betslip-systeminfo.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.BetslipSysteminfo = Backbone.Model.extend({
    initialize: function() {
      this.listenTo(
        svs.tipset.collections.matchlist,
        'buttonBet resetAll',
        this.update
      );
      this.listenTo(
        svs.tipset.models.betslipExpanded,
        'change:amount',
        this.update
      );
      this.listenTo(
        svs.tipset.models.sportkryss,
        'sportkryssUpdated',
        this.update
      );
      this.listenTo(
        svs.tipset.models.weekPicker,
        'nrOfWeeksUpdated',
        this.update
      );

      this.listenTo(svs.tipset.models.systems, 'change', this.update);

      this.update();
    },

    update: function() {
      this.set({
        nrOfHalfHedges: svs.tipset.collections.matchlist.getNrOfHalfHedges(),
        nrOfFullHedges: svs.tipset.collections.matchlist.getNrOfFullHedges(),
        system: svs.tipset.models.systems.getCurrentSystem()
      });

      if (svs.core.detect.feature('ft-betslip')) {
        var price = svs.utils.format.Currency(
          svs.tipset.models.betslipFooter.getPrice(),
          false
        );
        this.set({
          price: price,
          systemName: svs.tipset.models.systems.getSystemName()
        });
      }
    }
  });
})(Backbone, _, svs);

 })(window);